import { VIDEO_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const BROWSER_VIDEO_REPORT_ID = `browser${VIDEO_CAMPAIGN_SUFFIX}`;
